export const PERSONAL_CHAT_NAME_MAX_LENGTH = 80;

export function personalChatNameError(name: string): string | null {
  if (!name) return "Chat name can’t be empty.";
  if (name.length > PERSONAL_CHAT_NAME_MAX_LENGTH) {
    return `Chat name can’t exceed ${PERSONAL_CHAT_NAME_MAX_LENGTH} characters.`;
  }
  return null;
}
